<template>
  <div 
    class="notification-item p-3 border-bottom transition-all cursor-pointer" 
    :class="{ 'unread': !notification.read }"
    @click="$emit('click', notification)"
  >
    <div class="d-flex align-items-start">
      <div class="noti-icon-wrapper rounded-circle d-flex align-items-center justify-content-center mr-3" :class="levelClass">
        <i :class="typeIcon"></i>
      </div>
      <div class="flex-grow-1">
        <div class="d-flex justify-content-between align-items-start mb-1">
          <h5 class="noti-title h6 mb-0 font-weight-bold" :class="{ 'text-dark': !notification.read, 'text-muted': notification.read }">
            {{ notification.title }}
          </h5>
          <span class="small text-muted">{{ timeAgo }}</span>
        </div>
        <p class="noti-message small mb-0" :class="{ 'text-secondary': !notification.read, 'text-muted': notification.read }">
          {{ notification.message }}
        </p>
      </div>
      <div v-if="!notification.read" class="unread-dot bg-primary rounded-circle ml-2 mt-2" style="width: 8px; height: 8px;"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotificationItem',
  props: {
    notification: {
      type: Object,
      required: true
    }
  },
  computed: {
    levelClass() {
      switch (this.notification.level) {
        case 'warning': return 'bg-warning-light text-warning';
        case 'danger': return 'bg-danger-light text-danger';
        default: return 'bg-info-light text-info';
      }
    },
    typeIcon() {
      switch (this.notification.type) {
        case 'order': return 'fas fa-shopping-cart';
        case 'inventory': return 'fas fa-boxes';
        case 'finance': return 'fas fa-dollar-sign';
        case 'customer': return 'fas fa-user-friends';
        case 'user': return 'fas fa-user-shield';
        case 'system': return 'fas fa-cog';
        default: return 'fas fa-bell';
      }
    },
    timeAgo() {
      const date = new Date(this.notification.createdAt);
      const now = new Date();
      const diffInSeconds = Math.floor((now - date) / 1000);
      
      if (diffInSeconds < 60) return 'Vừa xong';
      if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)} phút trước`;
      if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)} giờ trước`;
      if (diffInSeconds < 2592000) return `${Math.floor(diffInSeconds / 86400)} ngày trước`;
      
      return date.toLocaleDateString('vi-VN');
    }
  }
}
</script>

